var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlHead2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 558,
    viewBox: "0 0 530 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Head / 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    d: "M106.001 322.793C106.001 297.629 200.313 88.3314 322.777 92.0494C492.667 97.2074 536.239 360.555 528.461 386.477C522.269 407.119 492.427 414.627 361.589 410.969C165.077 405.473 106.001 345.329 106.001 322.793Z",
    fill: "#2437A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.761 369.464C334.761 369.464 308.899 370.228 297.877 364.208L333.387 386.502L334.761 369.464Z",
    fill: "#CF3E83"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Face",
    d: "M330.1 198.179C359.91 213.232 406.853 240.837 430.727 275.275C426.549 305.008 416.338 344.88 392.393 360.802C379.213 369.562 355.213 370.642 334.755 369.462L330.075 427.542L265.315 406.082C265.315 406.082 271.735 338.022 274.515 313.402C261.095 301.222 236.235 293.582 236.193 272.902C236.193 265.762 240.373 253.362 255.815 253.342C276.533 253.322 273.595 278.142 273.595 278.142C294.538 286.297 315.927 224.183 330.1 198.179L330.1 198.179Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.979 278.103L405.779 313.983L388.607 313.639L390.979 278.103Z",
    fill: "#405FD3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M375.222 279.659C374.852 286.827 370.638 292.411 365.806 292.133C360.974 291.855 357.356 285.819 357.726 278.651C358.094 271.483 362.31 265.899 367.142 266.177C371.974 266.455 375.592 272.491 375.222 279.659Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.597 278.514C420.227 285.682 416.011 291.266 411.181 290.988C406.349 290.71 402.729 284.674 403.099 277.506C403.469 270.338 407.683 264.752 412.515 265.03C417.347 265.308 420.965 271.346 420.597 278.514Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 14",
    d: "M384.395 330.825C384.395 330.825 373.207 334.437 361.997 321.971",
    stroke: "#1C295E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 16",
    opacity: 0.398182,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M334.718 369.464C334.718 369.464 308.856 370.228 297.834 364.208L333.344 386.502L334.718 369.464Z",
    fill: "black"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlHead2);
export default __webpack_public_path__ + "static/media/Girl-Head-2.5f9be312.svg";
export { ForwardRef as ReactComponent };